import {
  getFirstVariant,
  getBaseVariant,
  getSecondVariant,
  getThirdVariant,
  getFourthVariant,
  getFifthVariant,
  getSixthVariant,
  getSeventhVariant,
  getEighthVariant,
  getNinthVariant,
  SNAPLINE_DELTA,
} from './AXSHARED';

export default () => {
  const prefix = '/models';
  const variants = [
    getBaseVariant('/images/AX512RM/AX512RM.png', [1, 2, 3, 4, 5, 6, 7, 8, 9]),
    getSixthVariant('/images/AX512RM/AX512RM_sixth_variant.png'),
    getNinthVariant('/images/AX512RM/AX512RM_ninth_variant.png'),
    getSeventhVariant('/images/AX512RM/AX512RM_seventh_variant.png'),
    getFirstVariant('/images/AX512RM/AX512RM_variant.png', [1, 2, 3, 4]),
    getThirdVariant('/images/AX512RM/AX512RM_third_variant.png'),
    getEighthVariant('/images/AX512RM/AX512RM_eighth_variant.png'),
    getFifthVariant('/images/AX512RM/AX512RM_fifth_variant.png'),
    getFourthVariant('/images/AX512RM/AX512RM_fourth_variant.png'),
    getSecondVariant('/images/AX512RM/AX512RM_second_variant.png'),
  ];

  const config = {
    url: `${prefix}/AX512RM/TShirt_AX512RM.gltf`,
    parts: variants[0].parts,
    overlays: variants[0].overlays,
    accessories: variants[0].accessories,
    hasNamedAccessories: true,
    groups: [
      {
        objects: [
          'TShirt_AX_Fronte_DX',
          'TShirt_AX_Fronte_SX',
          'TShirt_AX_ZipFake_Busto',
        ],
        snaplines: [
          { x: 0.25, delta: SNAPLINE_DELTA },
        ],
      },
      {
        objects: [
          'TShirt_AX_Fianco_DX',
        ],
      },
      {
        objects: [
          'TShirt_AX_Fianco_SX',
        ],
      },
      {
        objects: [
          'TShirt_AX_Retro',
        ],
        snaplines: [
          { x: 0.77, delta: SNAPLINE_DELTA },
        ],
      },
      {
        objects: [
          'TShirt_AX_Cuffia_DX',
        ],
      },
      {
        objects: [
          'TShirt_AX_Cuffia_SX',
        ],
      },
      {
        objects: [
          'TShirt_AX_Collo',
          'TShirt_AX_ZipFake_Collo',
        ],
      },
      {
        objects: [
          'TShirt_AX_Tasca',
        ],
        snaplines: [
          { x: 0.28, delta: 0.02 },
        ],
      },
      {
        objects: [
          'TShirt_AX_RiportiManiche',
        ],
      },
      {
        drawable: false,
        transparent: true,
        objects: [
          'TShirt_AX_RibattuteManiche',
        ],
      },
      {
        drawable: false,
        objects: [
          'TShirt_AX_Zip',
        ],
      },
      {
        drawable: false,
        objects: [
          'TShirt_AX_TascaElastico',
        ],
      },
    ],
    optionals: [
      {
        key: 'Tasca',
        objects: [
          'TShirt_AX_TascaZip',
          'TShirt_AX_TascaZipFettuccia',
          'TShirt_AX_TascaZipCursore',
        ],
      },
    ],
  };
  return { config, variants };
};
